import type * as React from "react";
import { memo } from "react";
import GridGappedContainer, { GridGappedContainerSize } from "./GridGappedContainer/GridGappedContainer";
import DateInput from "./DateInput";
import { useTranslation } from "react-i18next";

export interface Props {
  className?: string;
  isDateValidForSelection?: (date: Date) => boolean;
  isInvalid?: boolean;
  onPeriodUpdate: (from: Date | undefined, to: Date | undefined) => void;
  dateFrom?: Date;
  dateTo?: Date;

  minYear?: number;
  maxYear?: number;

  onChange?: (data: object) => void;
  onBlur?: () => void;
  value?: Date;

  disabled?: boolean;
}

const DatePeriodPicker: React.FC<Props> = ({
  isDateValidForSelection,
  isInvalid,
  onPeriodUpdate,
  dateFrom,
  dateTo,

  minYear,
  maxYear,

  className,

  onChange,
  onBlur,
  value,

  disabled,
}) => {
  const { t } = useTranslation();
  const isDayDisabled = (date: Date) => !isDateValidForSelection || !isDateValidForSelection(date);

  const onChangeWrapper = (date: Date, direction: string) => {
    if (onPeriodUpdate) {
      direction === "from" ? onPeriodUpdate(date, dateTo) : onPeriodUpdate(dateFrom, date);
    }
    if (onChange) {
      direction === "from" ? onChange({ start: date, end: dateTo }) : onChange({ start: dateFrom, end: date });
    }
  };

  return (
    <GridGappedContainer gapSize={GridGappedContainerSize.S_32} className={className}>
      <DateInput
        date={dateFrom ?? null}
        onChange={(date) => onChangeWrapper(date, "from")}
        onBlur={onBlur}
        isDayDisabled={isDayDisabled}
        className="flex-1"
        isInvalid={isInvalid}
        label={t("orderList.dateFrom")}
        data-test-id={"date-choose-from"}
        minYear={minYear}
        maxYear={maxYear}
        disabled={disabled}
      />
      <DateInput
        date={dateTo ?? null}
        onChange={(date) => onChangeWrapper(date, "to")}
        onBlur={onBlur}
        isDayDisabled={isDayDisabled}
        className="flex-1"
        isInvalid={isInvalid}
        label={t("orderList.dateTo")}
        data-test-id={"date-choose-to"}
        minYear={minYear}
        maxYear={maxYear}
        disabled={disabled}
      />
    </GridGappedContainer>
  );
};

export default memo(DatePeriodPicker);
